export class NotaCredito {
    tipoDocumentoModificacion:string;
    numeroDocumentoModificacion:string;
    fechaEmisionDocumentoModificado:Date;
    motivoModificacion:string;
}